import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Label from './../Input/Label'

export default class Range extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.number
  }
  static defaultProps = {
    disabled: false
  }

  onChange (e) {
    const { onValueChange } = this.props
    const { value } = e.target
    onValueChange(value)
  }

  render () {
    const { label, disabled, name, value, stepSize, minNum, maxNum } = this.props
    return (
      <div className={`custom-radio`}>
        <Label label={label} />
        <div className={'d-flex align-items-center'}>
          <input
            type={`range`}
            className={`custom-range`}
            disabled={disabled}
            name={name}
            defaultValue={value}
            onChange={this.onChange.bind(this)}
            step={stepSize}
            max={maxNum}
            min={minNum}
          />
          <div className={'ml-1'}>{value}</div>
        </div>
      </div>
    )
  }
}
